@if (state === 'SYNCING') {
  <h3 translate="CALLS.CALENDAR_SYNC.SYNCING_TITLE"></h3>
  <app-progress-loader indeterminate thin></app-progress-loader>
  <p translate="CALLS.CALENDAR_SYNC.SYNCING_MESSAGE"></p>
} @else {
  <h3 [translate]="'CALLS.CALENDAR_SYNC.' + state + '_TITLE'"></h3>
  <p [translate]="'CALLS.CALENDAR_SYNC.' + state + '_MESSAGE'"></p>
  <a routerLink="/app/settings/calendar" translate="CALLS.CALENDAR_SYNC.RECONNECT_LINK"></a>
}
